import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

const items = [
  {
    name: `Giới Thiệu`,
    slug: `/support/gioi-thieu`,
  },
  {
    name: `Chính Sách Chung`,
    slug: `/support/chinh-sach-chung`,
  },
  {
    name: `Điều Khoản`,
    slug: `/support/dieu-khoan`,
  },
  {
    name: `Chính Sách Bảo Mật`,
    slug: `/support/chinh-sach-bao-mat`,
  },
  {
    name: `Chính Sách Giao Hàng`,
    slug: `/support/chinh-sach-giao-hang`,
  },

  {
    name: `HD Đặt Hàng, Thanh Toán`,
    slug: `/support/huong-dan-dat-hang-thanh-toan`,
  },
  {
    name: `Cách Chăm Sóc Hoa`,
    slug: `/support/cach-cham-soc-hoa`,
  },
  {
    name: `Câu Hỏi Thường Gặp`,
    slug: `/support/cau-hoi-thuong-gap`,
  },
  // {
  //   name: `Thắc Mắc Và Khiếu Nại`,
  //   slug: `/support/thac-mac-va-thieu-nai`,
  // },
  // {
  //   name: `Chính Sách Đổi Trả, Hoàn Tiền`,
  //   slug: `/support/chinh-sach-doi-tra-hoan-tien`,
  // },
];

const Support = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({ title: `` });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true)
    getData();
  }, [id]);

  const getData = () => {
    axios
      .get(`/api/v1/posts/get-by-slug/${id}`, {
        params: {},
      })
      .then((res) => {
        setData(res.data);
        if (res.data == null) {
          setData({ title: `Tiêu Đề`, content: `Không có dữ liệu` });
        }
        setLoading(false)
      })
      .catch((err) => console.log(err));
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      {data.title && <div className="post-title">{data.title}</div>}
      <Box
        sx={{
          width: "1230px",
          display: "grid",
          gridTemplateColumns: "1fr 3fr",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, p: 3 }}>
          {items.map((item, idx) => (
            <Link
              style={{ textDecoration: "none", color: "#0184b7" }}
              to={item.slug}
              key={idx}
            >
              <Box
                sx={{
                  p: "10px 20px",
                  width: "100%",
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderRadius: "30px",
                  fontWeight: "bold",
                  transition: "all 0.3s",
                  "&:hover": {
                    backgroundColor: "#ccc",
                    transform: "scale(1.05)",
                  },
                }}
              >
                {item.name}
              </Box>
            </Link>
          ))}
        </Box>
        <Box sx={{ p: 3 }}>
          <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
        </Box>
      </Box>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300,
          }}
        >
          <CircularProgress sx={{ color: "#0184b7" }} />
        </Box>
      )}
    </Box>
  );
};

export default Support;
